var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ec-sidebar"},[(_vm.showLogo)?_c('logo',{attrs:{"collapse":_vm.isCollapse}}):_vm._e(),_vm._v(" "),_c('ec-menu'),_vm._v(" "),_c('div',{staticClass:"ec-menu__fold",on:{"click":_vm.toggleSideBar}},[_c('i',{class:_vm.isCollapse ?  'el-icon-s-unfold': 'el-icon-s-fold'})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-758c895c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/layout/EcSideBar.vue
// module id = null
// module chunks = 